import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import styles from './globalStyles.module.css';
import RootLayout from './RootLayout';
import ErrorPage from './pages/ErrorPage';
import TailgateForms from './pages/TailgateForms';
import EditForm from './pages/EditForm';
import Teams from './pages/Teams/Teams'
import CreateTeam from './pages/Teams/CreateTeam'
import EditTeam from './pages/Teams/EditTeam'
import Contacts from './pages/Contacts';
import Login from './pages/Login';
import Signup from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import SafetyAudit from './pages/SafetyAudits';
import Attendance from './pages/Attendance';
import SpotChecks from './pages/SpotChecks';
import Account from './pages/Account';
import Dashboard from './pages/Dashboard';
import Locations from './pages/Locations';
import NotFound from './pages/NotFound';
import Admins from './pages/Admins';
import ProtectedRoute from './pages/ProtectedRoute';
import EditIncident from './pages/EditIncident';
const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <ProtectedRoute Page={Dashboard} fetchIsAdmin={true} />
      },
      {
        path: '/tailgate-forms',
        element: <ProtectedRoute Page={TailgateForms} fetchIsAdmin={true} />
      },
      {
        path: "forms/:formId",
        element: <ProtectedRoute Page={EditForm} fetchIsAdmin={true} />
      },
      {
        path: "attendance/:formId",
        element: <ProtectedRoute Page={Attendance} />
      },
      {
        path: "teams",
        element: <ProtectedRoute Page={Teams} fetchIsAdmin={true}/>
      },
      {
        path: "createTeam",
        element: <ProtectedRoute Page={CreateTeam} />
      },
      {
        path: "teams/:teamId",
        element: <ProtectedRoute Page={EditTeam} fetchIsAdmin={true} />
      },
      {
        path: "contacts",
        element: <ProtectedRoute Page={Contacts} fetchIsAdmin={true} />
      },
      {
        path: "login",
        element: <ProtectedRoute Page={Login} redirectIfLoggedIn={true} />
      },
      {
        path: "signup",
        element: <ProtectedRoute Page={Signup} redirectIfLoggedIn={true} />
      },
      {
        path: "forgot-password",
        element: <ProtectedRoute Page={ForgotPassword} redirectIfLoggedIn={true} />
      },
      {
        path: "safety-audits/:formId",
        element: <ProtectedRoute Page={SafetyAudit} />
      },
      {
        path: "spot-checks/:safetyAuditId",
        element: <ProtectedRoute Page={SpotChecks} />
      },
      {
        path: "account",
        element: <ProtectedRoute Page={Account} />
      },
      {
        path: "locations",
        element: <ProtectedRoute Page={Locations} fetchIsAdmin={true} />
      },
      {
        path: "admins",
        element: <ProtectedRoute Page={Admins} fetchIsAdmin={true}/>
      },
      {
        path: "incidents/:incidentId",
        element: <ProtectedRoute Page={EditIncident}/>
      },
      {
        path: "*",
        element: <NotFound />
      },

    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <div className={styles[':global']}>
    <RouterProvider router={router} />
  </div>
  // </React.StrictMode>
);
